// extracted by mini-css-extract-plugin
export default {"key-value":"risk-item_key-value__YAmA+","label":"risk-item_label__wrqPr","divider":"risk-item_divider__SW8dJ"};